import { render, staticRenderFns } from "./OrganisationProfileView.vue?vue&type=template&id=481e7683&"
import script from "./OrganisationProfileView.vue?vue&type=script&lang=ts&"
export * from "./OrganisationProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationProfileView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrganisationProfileView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports